import { useToggle } from '@dfl/hook-utils';
import { PermissionCheck } from '@dfl/react-security';
import { Stack } from '@mui/material';
import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useProductDiscountDetails } from '../../contexts/ProductDiscountDetails';
import { useDeleteProductDiscountProduct } from '../../hooks/useDeleteProductDiscountProduct';
import { OFFER_STATUS } from 'modules/sales-offer/common/constants/offer.enum';
import { ConfirmRowAction } from '@dfl/mui-admin-layout';
import { DeleteOutline } from '@mui/icons-material';

type UserStatusProps = {
  rowId: string;
  record: any;
};

const ProductOfferDetailRowActions = ({ rowId }: UserStatusProps) => {
  const { t } = useTranslation('productDiscount');
  const { id, discount } = useProductDiscountDetails();
  const { isOpen, onClose, onOpen } = useToggle();
  const { mutate, isPending, error } = useDeleteProductDiscountProduct(id, rowId, onClose);

  const { confirmation, disabled } = useMemo(() => {
    const isActive = discount?.status === OFFER_STATUS.ACTIVE;
    const isDisabled = discount?.status === OFFER_STATUS.DISABLED;

    return {
      confirmation: isActive ? 'deleteConfirmation.active' : 'deleteConfirmation.all',

      disabled: isDisabled,
    };
  }, [discount?.status]);

  return (
    <Stack direction='row' spacing={1} justifyContent={'center'}>
      <PermissionCheck permissions={'BULK_PRODUCT_DISCOUNT:DELETE'}>
        <ConfirmRowAction
          isOpen={isOpen}
          icon={<DeleteOutline color='error' />}
          onOpen={onOpen}
          disabled={disabled}
          onClose={onClose}
          confirmationMessage={t(confirmation)}
          error={error}
          isLoading={isPending}
          onConfirm={mutate}
          tooltip={t('common:deleteOffer')}
        />
      </PermissionCheck>
    </Stack>
  );
};

export default memo(ProductOfferDetailRowActions);
